var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row boxes-row"},_vm._l((_vm.leaderboards),function(box){return _c('div',{key:box.link,staticClass:"col-lg-4"},[_c('LeaderboardBox',{attrs:{"box":box}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }